const MedicineBlockchain = {
    //network info
    averageBlockTime: 2,
    chainId: '0x115c', //4444
    name: 'Medicine Blockchain',
    shortName: 'mbc',
    token: 'VBC',
    type: 'Ethereum 1.0',
    timeInterval: 5_000,

    //endpoint
    endpoint: process.env.MEDICINE_BLOCKCHAIN_ENDPOINT,
    chainApiEndpoint: process.env.MEDICINE_BLOCKCHAIN_API_ENDPOINT,
    // infoApiEndpoint: process.env.MEDICINE_BLOCKCHAIN_INFO_ENDPOINT,

    //style
    chartStyle: ['#f7b1b0', '#cf83f3'],
    color: {
        from: '#f7b1b0',
        to: '#cf83f3',
        fromPosition: '25.72%',
        toPosition: '113.63%'
    },

    //image
    backgroundImage: 'https://res.cloudinary.com/vbchain/image/upload/v1627889694/block_explorer/mbcHome_ozk2vt.svg',

    networkIcon: 'https://res.cloudinary.com/dwcf5cmei/image/upload/v1741245358/vbchain/hfnf42okk4tx8idbkxxc.png',
    averageBlockTimeIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627891807/block_explorer/GeneralInfo/Medical%20Blockchain%20Testnet/mbcTestnetBlockTime_g1atwk.svg',
    totalTransactionsIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627891807/block_explorer/GeneralInfo/Medical%20Blockchain%20Testnet/mbcTestnetTransaction_pgtxpx.svg',
    totalActiveAddressesIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627891807/block_explorer/GeneralInfo/Medical%20Blockchain%20Testnet/mbcTestnetAccount_hgpum3.svg',
    latestBlockIcon:
        'https://res.cloudinary.com/vbchain/image/upload/v1627891807/block_explorer/GeneralInfo/Medical%20Blockchain%20Testnet/mbcTestnetBlock_pyyqdu.svg'
}

module.exports = MedicineBlockchain
